<template>
  <div class>
    <div class="d-flex align-items-center " v-if="isLoading">
      <placeholders class="d-flex flex-grow-1 justify-content-between" :rounded="true">
        <placeholders-img class="mr-2" style="height: 2.75rem" />
        <placeholders-img class="mr-2" style="height: 2.75rem" />
        <placeholders-img class="mr-2" style="height: 2.75rem" />
        <placeholders-img class="mr-2" style="height: 2.75rem" />
        <placeholders-img class="" style="height: 2.75rem" />
        <!-- <div class="row">
          <div class="col">
            <placeholders-img style="height: 100%" />
          </div>
          <div class="col">
            <placeholders-img style="height: 3rem" />
          </div>
          <div class="col">
            <placeholders-img style="height: 3rem" />
          </div>
          <div class="col">
            <placeholders-img style="height: 3rem" />
          </div>
          <div class="col">
            <placeholders-img style="height: 3rem" />
          </div>
        </div> -->
      </placeholders>
    </div>
    <template v-else>
      <div>
        <div v-if="!appointments.length" class="d-flex text-hint align-items-center flex-column px-2 pt-0">

          <font-awesome-icon :icon="['far', 'calendar']" size="lg" class="text-muted" />
          <span class="text-muted">No appointments today</span>
        </div>
        <div v-else data-v-tour="appointmentPicker">
          <slider ref="slider" :sliderOptions="sliderOptions" :height="height || '50px'" :vertical="vertical" :disabled="!isSliderEnabled" :hideButtons="hideButtons" :sliderClass="tourFixClass">
            <template slot-scope="props">
              <slide v-for="a in appointments" :key="a.id">
                <appointment-picker-item v-bind="a" @selected="s=> withPremium(patientSelected, false, s)" :style="{margin: vertical ? '.5rem 0' : '0 .5rem'}" :class="{
                    selected:
                      selectedPatient && selectedPatient.id === a.patient_id,
                  }" :isSelectable="
                    !props.isSliding &&
                    (!selectedPatient || selectedPatient.id !== a.patient_id)
                  " />
              </slide>
            </template>
          </slider>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
import AppointmentPickerItem from '@/components/referrals/integration/AppointmentPickerItem'
import Slider from '@/components/Slider'
import { Slide } from 'hooper'
export default {
  props: ['height', 'vertical', 'hideButtons'],
  components: {
    Slider,
    Slide,
    AppointmentPickerItem,
  },
  data() {
    return {
      selectedPatient: null,
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('appointments', ['isLoading', 'isLoaded', 'appointments']),
    ...mapState('tour', ['activeTour']),
    ...mapGetters('auth', ['isIntegrationActive']),
    ...mapGetters('tour', ['currentTarget']),
    sliderOptions() {
      return {
        itemsToShow: 2,
        initialSlide: this.initSlide,
      }
    },
    initSlide() {
      return (
        this.appointments.length &&
        this.appointments
          .map((s, i) => ({ i, abs: s.abs }))
          .sort((a, b) => a.abs - b.abs)[0].i
      )
    },
    slides() {
      return this.appointments.map((a) => ({
        id: a.id,
        title: a.patient,
        content: `${moment(a.datetime).format('LT')}<br /><b>${moment()
          .add(a.when, 'seconds')
          .fromNow()}</b>`,
      }))
    },
    isSliderEnabled() {
      return this.appointments.length > 5
    },
    tourFixClass() {
      return this.activeTour &&
        this.currentTarget ==
          '[data-v-tour="appointmentPicker"] .hooper-slide:nth-child(11) > div'
        ? 'v-tour__target--parent-highlight'
        : ''
    },
  },
  async mounted() {
    if (!this.isLoaded && !this.isLoading)
      this.$store.dispatch('appointments/load')
  },

  methods: {
    patientSelected(patient, event) {
      this.selectedPatient = patient
      this.$emit('patientSelected', patient, event)
    },
    update() {
      this.$refs.slider.update()
    },
  },
}
</script>

<style>
.hooper:focus {
  outline: none;
}
.is-vertical .hooper-slide {
  margin: 5px 0;
}
</style>
